import { Loader2 } from 'lucide-react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { landingPathFor } from '@/lib/landing';
import { useAuthStore } from '@/stores/auth-store';

/** Redirects already-authenticated users away from login/register pages. */
export function PublicOnlyRoute() {
  const { user, isAuthenticated, bootstrapped } = useAuth();
  const impersonating = useAuthStore((s) => s.impersonation !== null);

  // Wait for session restore so a returning user never sees the login form flash.
  if (!bootstrapped) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="size-6 animate-spin text-primary" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={landingPathFor(user, { impersonating })} replace />;
  }

  return <Outlet />;
}
